import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'is24-corecss'
import { IconS24Bin24, IconS24Pen24 } from '@is24/cosma-ui-icons'

export const PrimaryFooterBtn: React.FC<{
  selectedCount: number
  onEditTitle: () => void
}> = ({ selectedCount, onEditTitle }) => {
  const { t } = useTranslation()
  const editTitleLabel = t('wizard.screen.multimedia.webview.modal.button.editTitle')

  return selectedCount > 0 ? (
    <Modal.PrimaryFooterButton
      variant='filledDefault'
      label={editTitleLabel}
      leftIcon={<IconS24Pen24 />}
      onClick={onEditTitle}
    />
  ) : undefined
}

export const SecondaryFooterBtn: React.FC<{
  selectedCount: number
  onDeleteSelected: () => void
}> = ({ selectedCount, onDeleteSelected }) => {
  const { t } = useTranslation()
  const deleteLabel = t('wizard.screen.multimedia.webview.modal.button.delete')
  const deleteLabelPlural = t('wizard.screen.multimedia.webview.modal.button.deletePlural')

  return selectedCount > 0 ? (
    <Modal.SecondaryFooterButton
      label={selectedCount === 1 ? deleteLabel : `${deleteLabelPlural} (${selectedCount})`}
      leftIcon={<IconS24Bin24 />}
      onClick={onDeleteSelected}
    />
  ) : undefined
}
